module.exports = __webpack_public_path__ + "img/icon_service_one.f60a27d3.svg";